import { Grid } from "@mui/material";
import NavigationDrawer from "../../components/drawer/NavigationDrawer";
import { NAVIGATION_DRAWER_TYPE_ICO} from "../../components/drawer/NavigationDrawer/NavigationDrawer";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import IcoReportsTabs from "../../components/tabs/IcoReportsTabs/IcoReportsTabs";


export default function IcoReportsPage(props) {

  const { pageName } = props;


  return (
    <NavigationDrawer
      drawerType={NAVIGATION_DRAWER_TYPE_ICO}
      pageName={pageName}
    >
      <DefaultPageWrapper titleKey={"ico_reports"}>
        <Grid
            container
            item
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            rowSpacing={1}
          >
            <Grid item xs={12}>
              <IcoReportsTabs  />
            </Grid>
          </Grid>
      </DefaultPageWrapper>
    </NavigationDrawer>
  );
}
